import { CreateMTTScreen } from '@/screens/tournament/CreateMTTScreen'

export default function CreateMTTRoute() {
  return <CreateMTTScreen />
}
